import { render, staticRenderFns } from "./blockEmbed.vue?vue&type=template&id=bc668140&"
import script from "./blockEmbed.vue?vue&type=script&lang=js&"
export * from "./blockEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports